/* import the fontawesome core, import config so we can set a default style */
import { all } from '@awesome.me/kit-a8e67d6597/icons'
import { config, type IconDefinition, library } from '@fortawesome/fontawesome-svg-core'
/* import font awesome icon component */
import { FontAwesomeIcon, FontAwesomeLayers, FontAwesomeLayersText } from '@fortawesome/vue-fontawesome'
import { vMaska } from 'maska/vue'
import PrimeVue from 'primevue/config'
import Tooltip from 'primevue/tooltip'
import { createApp } from 'vue'
import { VueEmailPlugin } from 'vue-email'
import { LoadingPlugin } from 'vue-loading-overlay'
import Toast, { type PluginOptions } from 'vue-toastification'
import { AppInsightsPlugin, type AppInsightsPluginOptions } from 'vue3-application-insights'
import Datepicker from 'vuejs3-datepicker'

import App from '@/App.vue'
import router from '@/router'
import { pinia } from '@/stores'
import customPreset from '@/theme/primevue-preset'

/* add icons to the library */
library.add(all as IconDefinition[])
config.styleDefault = 'solid'

import 'vue-multiselect/dist/vue-multiselect.css'
import 'vue-loading-overlay/dist/css/index.css'
import 'primeicons/primeicons.css'
import '@/scss/user.scss'
import '@/scss/theme.scss'

const aiOptions: AppInsightsPluginOptions = {
	appName: 'Nuevo Peco Front End',
	cloudRole: 'frontend',
	cloudRoleInstance: import.meta.env.VITE_ENV,
	connectionString: import.meta.env.VITE_APP_INSIGHTS_CONNECTION_STRING,
	router: router,
	trackAppErrors: true,
	trackInitialPageView: true
}

const toastOptions: PluginOptions = {
	containerClassName: 'test',
	transition: 'Vue-Toastification__bounce',
	maxToasts: 20,
	newestOnTop: true
}

// create app
const app = createApp(App)

app.use(router)
app.use(LoadingPlugin)
app.use(VueEmailPlugin)
app.use(AppInsightsPlugin, aiOptions)
app.use(Toast, toastOptions)
app.use(pinia)
app.use(PrimeVue, {
	theme: {
		preset: customPreset,
		options: {
			darkModeSelector: '.dark-mode',
			cssLayer: false
		}
	}
})

app.component('FontAwesomeIcon', FontAwesomeIcon)
app.component('FontAwesomeLayers', FontAwesomeLayers)
app.component('FontAwesomeLayersText', FontAwesomeLayersText)
app.component('DatePicker', Datepicker)

app.directive('maska', vMaska)
app.directive('tooltip', Tooltip)

router.isReady().then(() => {
	app.mount('#app')
})

import '@popperjs/core'
import 'bootstrap'
